export default [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' }
];



// WEBPACK FOOTER //
// ./src/conf/dashboardLanguages.js